export default __webpack_public_path__ + "static/media/DISS-CO_SIP_Data_Protection_and_Security_FAQ_20260630.4364ee25.pdf";